import React, { lazy, Suspense } from 'react';

import { Route, Switch } from 'react-router-dom';

const GuestProfileDetailContainer = lazy(
  () => import('../containers/GuestProfileDetailContainer/GuestProfileDetailContainer'),
);

const GuestProfileRoutes: React.FC = () => {
  return (
    <Suspense fallback={null}>
      <Switch>
        {/* Single guest profile view - accessed via text message link */}
        <Route exact path="/guests/:zoneId/profiles/:personUuid">
          <GuestProfileDetailContainer />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default GuestProfileRoutes;
